import * as marietta from '../../..';
import * as marietta3d from '../../../../marietta3d';
import { ModelLoadSystem } from '../../../view3d/webcad/WebCad3dModelLoadSystem';

// Menu to choose various designs in exterior
export default class DesignOptionMenu {
  data: marietta3d.AutoGen.ConstructionModel;

  viewObj;

  /**
   * コンストラクタ
   */
  constructor() {
    this.viewObj = document.getElementById('tabDesignOptions');

    // 情報をGET
    this.data = marietta.webcad.WebCADGlobal.autoMain.Model;
    const self = this;
    document.getElementById('btnChangeDesignOption').addEventListener('click', self.okBtnEventHandler);
    document.getElementById('btnCancelDesignOption').addEventListener('click', self.init);
  }

  /**
   * 初期設定
   */
  init = () => {
    console.log('init');

    // 設定されている値を適用
    console.log(marietta.webcad.WebCADGlobal.autoMain.Model);

    const self: marietta.webcad.view.leftMenu3d.DesignOptionMenu = this;

    // パラメータの表示を更新
    self.updateParam();
  };

  /**
   * キャンセルボタンが押された
   */
  cancelBtnEventHandler = () => {
    this.init();
  };

  /**
   * OKボタンが押された
   */
  okBtnEventHandler = () => {
    const self = this;

    // [3D] ConstructionModelに反映
    marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), () => {
      setTimeout(() => {
        self.setParamConstructionModel();
      }, 500);
    });
  };

  /**
   * ダイアログに表示するパラメータを更新
   */
  updateParam() {
    if (!this.data) return;

    console.log('updateParam');
    console.log(this.data);

    // 窓枠
    this.setSelectioToView('design_madowaku', this.data.Option.madowaku.toString());
    // 面格子
    this.setSelectioToView('design_mengoushi', this.data.Option.menGousi.toString());
    // フラワーボックス
    this.setSelectioToView('design_flowerbox', this.data.Option.flowerBox.toString());
    // 幕板
    this.setSelectioToView('design_makuita', this.data.Option.makuita.toString());
    // ティンバー
    this.setSelectioToView('design_timber', this.data.Option.timber.toString());
    // 妻飾り
    this.setSelectioToView('design_tsumakazari', this.data.Option.tumaKazari.toString());

    // 庇
    this.setSelectioToView('design_hisashi', this.data.Option.hisasi.toString());
    // 鎧戸
    this.setSelectioToView('design_yoroido', this.data.Option.yoroido.toString());

    // 出隅
    this.setSelectioToView('design_desumi', this.data.Option.desumiSousyoku.toString());
  }

  /**
   * ダイアログに表示するパラメータを更新
   */
  setSelectioToView = (selectionName: string, value: string): void => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(selectionName);

    switch (selectionName) {
      case 'design_desumi':
      case 'design_yoroido':
      case 'design_hisashi':
        elements[0].removeAttribute('checked');
        (elements[0] as HTMLInputElement).checked = false;
        if (value === '1') {
          elements[0].setAttribute('checked', 'checked');
          (elements[0] as HTMLInputElement).checked = true;
        }
        break;
      default:
        for (let i: number = 0; i < elements.length; i += 1) {
          if ((elements[i] as HTMLInputElement).value === value) {
            elements[i].setAttribute('checked', 'checked');
            (elements[i] as HTMLInputElement).checked = true;
          } else {
            elements[i].removeAttribute('checked');
            (elements[i] as HTMLInputElement).checked = false;
          }
        }
        break;
    }
  };

  /**
   * [3D] ConstructionModelに反映
   */
  setParamConstructionModel = () => {
    const self = this;

    // パラメータをConstructionModelにセット
    self.data.Option.madowaku = self.getSelectedRadioButton('design_madowaku');
    self.data.Option.menGousi = self.getSelectedRadioButton('design_mengoushi');
    self.data.Option.flowerBox = self.getSelectedRadioButton('design_flowerbox');
    self.data.Option.makuita = self.getSelectedRadioButton('design_makuita');
    self.data.Option.timber = self.getSelectedRadioButton('design_timber');
    self.data.Option.tumaKazari = self.getSelectedRadioButton('design_tsumakazari');

    // チェックボックス類
    self.data.Option.desumiSousyoku = self.getCheckboxStatus('design_desumi');
    self.data.Option.yoroido = self.getCheckboxStatus('design_yoroido');
    self.data.Option.hisasi = self.getCheckboxStatus('design_hisashi');

    // 3Dのボタンの表示をデフォルトに戻す
    marietta.webcad.WebCADGlobal.init3dMenu();

    // save camera state
    marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();
    // keep camera state
    marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;
    new ModelLoadSystem().request3D();
    // [2D] modelParamに反映
    this.setModelParamJson();

    // setが完了したらダイアログを閉じる
    marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
  };

  /**
   * ラジオボタンの選択されている
   * */
  getSelectedRadioButton = (key: string): number => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(key);
    for (let i: number = 0; i < elements.length; i += 1) {
      console.log((elements[i] as HTMLInputElement).getAttribute('checked'));

      if ((elements[i] as HTMLInputElement).checked) {
        return parseInt((elements[i] as HTMLInputElement).value, 10);
      }
    }
    return null;
  };

  /**
   * チェックボックスの状態の取得
   * */
  getCheckboxStatus = (key: string): number => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(key);
    if ((elements[0] as HTMLInputElement).checked) {
      return 1;
    }
    return 0;
  };

  /**
   * [2D] modelParamに反映
   */
  setModelParamJson() {
    const jsonData = this.data.writeJSON();
    marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
  }
}
